import dayjs from "dayjs";
import { useEffect } from "react";
import { constructDucFlowBasedFromState, constructStepLabelsFromState } from "./components/DucFlows";
import { steps } from "./DUCProcess";


const UseGetStepHookDucProcess = (data: any, setDUCInfo: Function,  setCurStep: Function,
    setExpiryCheck: Function, setStepLabels: Function, expiryCheck: any, DUCInfo: any,
    formType: any, userName: string, isGroup: boolean, isEdit: boolean, isAddSub: boolean, isSub: boolean) => {
    // @ts-ignore
    const attestationEnabled = window.env.attestationEnabled;
    //This hook is to get the correct step for the duc process based off of the current state of the application
    useEffect(() => {
        const flow = constructDucFlowBasedFromState(expiryCheck, attestationEnabled, isGroup)
        if(data){
            if(isEdit){
                if(data?.status === 'Approved'){
                    if (isAddSub){
                        setCurStep(flow.indexOf(steps.SUBRECIPIENTS) + 1)

                    }
                }
            }
            else if(data?.status === 'Submitted'){
                setCurStep(flow.indexOf(steps.AUTHORIZEDOFFICIAL) + 1)
            }

            else if(data?.status === 'InProgress'){
                setCurStep(flow.indexOf(steps.REVIEW) + 1)
            }

            else if(data?.status === 'Approved'){

                if(isSub){
                    setCurStep(flow.indexOf(steps.REVIEW) + 1)
                }
                else{
                    const curDate = new Date();
                    const expiryDay = dayjs(new Date(data?.expiresOn));
                    curDate.setMonth(curDate.getMonth() + 3);
                    if(expiryDay.isBefore(curDate, 'day')){
                        setExpiryCheck(true);
                    }
                    else{
                        setCurStep(flow.indexOf(steps.REVIEW) + 1)
                    }
                }
            }

            else if (data?.status === 'Expired'){
                setExpiryCheck(true);
                setCurStep(flow.indexOf(steps.RECIPIENTS) + 1)
            }


            if(expiryCheck){
                setDUCInfo({ ...DUCInfo, ducType: formType, type: 'Renewal', userName: userName, isGroup: isGroup })
            }
            else{
                setDUCInfo({ ...DUCInfo, ducType: formType, type: 'New', userName: userName, isGroup: isGroup })
            }

            setStepLabels(constructStepLabelsFromState(flow))

        }
    }, [data])

}

export default UseGetStepHookDucProcess